export default function initExpandableCards() {
    const wrappers = document.querySelectorAll('.expandable-cards__wrapper');

    if (!wrappers.length) return;

    wrappers.forEach(wrapper => {
        const items = wrapper.querySelectorAll('.expandable-cards__item');

        items.forEach(item => {
            item.addEventListener('click', (e) => {
                // If clicking the button, let it propagate (navigate)
                if (e.target.closest('.expandable-cards__btn')) return;

                // Otherwise, prevent default if it was a link (though we removed the link wrapper)
                // and toggle active class
                
                // Remove active from all siblings
                items.forEach(sibling => sibling.classList.remove('active'));
                
                // Add active to clicked item
                item.classList.add('active');
            });
        });
    });
}
